import React from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { RadioButton } from "components";

import styles from "./businessInfo.module.scss";

const PaperStatement = () => {
	return (
		<Row className="mt-4">
			<Col>
				<div className="mb-4">
					Do You Want to Print Paper Statement?
				</div>
				<Row>
					<Col lg={3}>
						<Field
							component={RadioButton}
							value="true"
							className={styles.radioButton}
							name="isPrintingPaperStatementEnabled"
							label="Yes"
							type="radio"
							id="paperStatementTrue"
						/>
					</Col>
					<Col lg={3}>
						<Field
							component={RadioButton}
							value="false"
							className={styles.radioButton}
							name="isPrintingPaperStatementEnabled"
							label="No"
							type="radio"
							id="paperStatementFalse"
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};

export default PaperStatement;
